<div class="content">
  <div class="informationRow">
    <label class="informationLabel">Rep Office to be replaced:</label>
    <label class="informationLabel">{{ organization.description }}</label>
  </div>
  <p>This process will deactivate the rep office listed above and will give access to all of their
    quotes and orders to the replacement that you pick from the list below. Since this can be a very lengthy
    process, it will be executed in the background and email messages will be sent after the process has completed.
  You will be notified if any errors occur in the process.</p>
  <div class="inputRow">
    <mat-form-field class="inputField">
      <mat-label>Replacement Rep Office:</mat-label>
      <mat-select [(ngModel)]="newRepId">
        @for (rep of replacementReps(); track rep) {
          <mat-option [value]="rep.code">{{ rep.description }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="inputRow">
    <mat-form-field class="inputField">
      <mat-label>Cancel Date:</mat-label>
      <input matInput [matDatepicker]="cancelDatePicker" name="cancelDateInput" [(ngModel)]="cancelDate"/>
      <mat-datepicker-toggle matSuffix [for]="cancelDatePicker"></mat-datepicker-toggle>
      <mat-datepicker id="cancelDatePicker" #cancelDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div class="buttonRow">
    <span class="spacer"></span>
    <button (click)="cancel()" matButton="elevated" class="inputButton warn-button">
      <span>
        <mat-icon class="size-16">cancel</mat-icon>
        <label class="buttonLabel">Abort Change</label>
      </span>
    </button>
    <button (click)="replaceRep()" matButton="elevated" class="inputButton primary-button">
      <span>
        <mat-icon class="size-16">done</mat-icon>
        <label class="buttonLabel">Replace Rep</label>
      </span>
    </button>
  </div>
</div>
